import React from 'react'
import { Field } from 'redux-form'
import CheckBoxField from '../../../../components/Form/CheckboxField'
import getFormValidations from "./formValidations";

// binding for redux-form
const Input = ({ input: {value, onChange}, meta: {touched, error}, style, path, editable, disabled, t}) =>  {
    return <CheckBoxField label={path} value={value} style={style} onChange={onChange} readOnly={!editable} disabled={disabled || !editable} t={t} touched={touched} error={error}/>
}

// the binding function has to be outside to avoid re-rendering
// https://github.com/erikras/redux-form/issues/1094

class FormCheckboxField extends React.Component {

    shouldComponentUpdate(nextProps) {
        return JSON.stringify(this.props) !== JSON.stringify(nextProps)
    }

    render() {
        const { field, t, objectMode, editObjectValues } = this.props
        const validations = getFormValidations(field, t, [], editObjectValues)
        return (
            <Field
                name={field.path}
                path={field.tKey || field.path}
                component={Input}
                validate={validations}
                editable={!field.editable ? objectMode === 'newObject' : field.editable  }
                disabled={field.disabled}
                style={field.style}
                t={t}
            />
        )
    }
}

export default FormCheckboxField
